import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useInactivityTimeout } from '../../hooks/useInactivityTimeout';
import InactivityWarningDialog from './InactivityWarningDialog';

export default function InactivityGuard({ children }) {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleTimeout = useCallback(async () => {
    await logout();
    navigate('/');
  }, [logout, navigate]);

  const { showWarning, secondsLeft, resetTimer } = useInactivityTimeout({
    timeoutMs: 10 * 60 * 1000,
    warningMs: 60 * 1000,
    onTimeout: handleTimeout,
    enabled: !!currentUser
  });

  return (
    <>
      {children}
      <InactivityWarningDialog
        open={showWarning}
        secondsLeft={secondsLeft}
        onStayLoggedIn={resetTimer}
      />
    </>
  );
}
